// Public seat message: hidden at 6+ free seats, exact counts stay admin-only.
export const LOW_SEAT_LIMIT = 5;

export function seatStatus(s) {
  if (s.waitlist_open) return { tone: "full", text: "Betelt – jelentkezés várólistára" };
  if (!s.open) return { tone: "closed", text: "Jelentkezés lezárva" };
  if (s.free <= LOW_SEAT_LIMIT) return { tone: "low", text: `Már csak ${s.free} szabad hely!` };
  return null;
}
